import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CentralCatalogueService } from '../../../services/central-catalogue/central-catalogue.service';
import { ToastService } from '../../../services/toast/toast.service';
import { LoaderComponent } from '../../../atoms/loader/loader.component';

// activate / deactivate a guest house or room, with a reason. self-saving.
@Component({
  selector: 'app-cc-state-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent],
  templateUrl: './cc-state-dialog.component.html',
  styleUrls: ['../cc-dialog-form.scss', '../../../../common-style/ac-dialog.scss'],
})
export class CcStateDialogComponent implements OnInit {
  isLoading: boolean = false;
  status: string = 'INACTIVE';
  statusReason: string = '';
  applyToRooms: boolean = false;
  reasons: string[] = [];
  private allReasons: any = null;

  constructor(
    public dialogRef: MatDialogRef<CcStateDialogComponent>,
    private catalogueService: CentralCatalogueService,
    private toastService: ToastService,
    @Inject(MAT_DIALOG_DATA)
    public data: { kind: 'set' | 'room'; name: string; ids: number[]; currentStatus: string }
  ) {}

  ngOnInit(): void {
    // suggest the opposite of the current status
    this.status = (this.data.currentStatus || '').toUpperCase() === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
    this.catalogueService.getStatusReasons().subscribe({
      next: (res: any) => {
        this.allReasons = res?.data?.reasons || null;
        this.refreshReasons();
      },
      error: () => {
        this.allReasons = null;
      },
    });
  }

  refreshReasons(): void {
    if (!this.allReasons) return;
    this.reasons = this.status === 'ACTIVE' ? this.allReasons.active : this.allReasons.inactive;
    this.statusReason = '';
  }

  get title(): string {
    return this.data.kind === 'set' ? 'Change guest house status' : 'Change room status';
  }

  submit(): void {
    if (!this.statusReason) {
      this.toastService.error('Pick a reason.');
      return;
    }
    this.isLoading = true;
    const payload = {
      ids: this.data.ids,
      status: this.status,
      statusReason: this.statusReason,
      applyToRooms: this.data.kind === 'set' ? this.applyToRooms : undefined,
    };
    const request =
      this.data.kind === 'set'
        ? this.catalogueService.setSetStates(payload)
        : this.catalogueService.setAccommodationStates(payload);

    request.subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Status updated.');
        this.isLoading = false;
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to update the status.');
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
